import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Panel } from "@/components/common";
import { api, formatApiError } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export const NotesPanel = ({ booking, onUpdated }) => {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const notes = [...(booking.activity_notes || [])].reverse();

  const add = async () => {
    if (!text.trim()) return;
    setSaving(true);
    try {
      const { data } = await api.post(`/bookings/${booking.id}/notes`, { text });
      onUpdated(data);
      setText("");
      toast.success("Note added");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Panel title="Notes & updates">
      <div className="space-y-2">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Add a note – e.g. customer called to change time" data-testid="note-input" />
        <Button onClick={add} disabled={saving || !text.trim()} size="sm" data-testid="btn-add-note" className="bg-[#0E1E38] hover:bg-[#162A4D]">
          <Send className="h-3.5 w-3.5" /> Add note
        </Button>
      </div>
      <ul className="mt-5 space-y-3" data-testid="notes-list">
        {notes.length === 0 && <li className="text-sm text-slate-400">No notes yet.</li>}
        {notes.map((n, i) => (
          <li key={i} className="border-l-2 border-sky-300 pl-3" data-testid={`note-item-${i}`}>
            <p className="whitespace-pre-wrap text-sm text-slate-800">{n.text}</p>
            <p className="mt-0.5 text-xs text-slate-400">{n.author} · {fmtDateTime(n.created_at)}</p>
          </li>
        ))}
      </ul>
    </Panel>
  );
};
